"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authModuleIds = void 0;
exports.authModuleIds = {
    SIGN_IN_WITH_PROVIDER_MODAL_MODULE: 'SIGN_IN_WITH_PROVIDER_MODAL_MODULE',
    TRANSFORM_TO_CREATOR: 'TRANSFORM_TO_CREATOR',
};
